import React, { useMemo } from 'react';
import './styles.css';
import { useSelector } from 'react-redux';
import { filterStateSelector } from 'store/ui/selectors';
import { getActiveSubcategoryName } from 'components/CLPFilters/helpers';
import { DeviceSize, useWindowSize } from 'hooks/useWindowSize';
import Show from 'components/Functional/Show';
import cx from 'classix';
import { TrackingProp } from 'react-tracking';
import itly from 'itly';
import { CLPFilter, SubcategoryFilter } from '../../types/Category';
import { useFilterHandlers } from '../../hooks/useFilterHandlers';

interface Props {
  filters: CLPFilter[];
  subcategoryFilters: SubcategoryFilter[];
  tracking: TrackingProp;
}

const SubcategoryGrid: React.FC<Props> = ({ filters, subcategoryFilters }) => {
  const { deviceSize } = useWindowSize();

  const { handleSingleFilterSelected } = useFilterHandlers(filters);

  const filterState = useSelector(filterStateSelector);

  const activeSubcategoryName = useMemo(() => getActiveSubcategoryName(filterState, subcategoryFilters), [filterState, subcategoryFilters]);

  const isMobile = deviceSize === DeviceSize.SMALL;

  const setCategoryFilter = (filter: SubcategoryFilter) => {
    const { name, filterName, filterValue } = filter;
    handleSingleFilterSelected(filterName, filterValue);

    itly.visualNavClicked({
      subcategory_name: name,
      filter_option: filterName,
      filter_value: filterValue
    });
  };

  return (
    <div className={cx('subcategory-list', isMobile && 'mobile')}>
      {subcategoryFilters.map(filter => {
        const { name, description, image } = filter;
        return (
          <div key={name}
               className={cx('subcategory-item', name === activeSubcategoryName && 'active', isMobile && 'mobile')}
               onClick={() => setCategoryFilter(filter)}>

            <img src={image[0]?.url} alt={name} />

            <div className="subcategory-header">{name}</div>

            <Show when={!isMobile}>
              <div className="subcategory-description">{description}</div>
            </Show>
          </div>
        );
      })}
    </div>
  );
};

export default SubcategoryGrid;